import { render, staticRenderFns } from "./u-tab-punch.vue?vue&type=template&id=26ce576e&scoped=true&"
import script from "./u-tab-punch.vue?vue&type=script&lang=js&"
export * from "./u-tab-punch.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-punch.vue?vue&type=style&index=0&id=26ce576e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ce576e",
  null
  
)

export default component.exports